module.exports = __webpack_public_path__ + "img/clear_night.ef473ad9.svg";